/* 在请求token中添加token*/
import store from '../store/index';
import md5 from 'js-md5';
import storage from '@/utils/storage';

/* 对象转拼接串的方法*/
function pars(param, key, encode) {
    if (param == null) param = '';
    var arr = [];
    var t = typeof(param);
    if (t == 'string' || t == 'number' || t == 'boolean') {
        arr.push(key + '=' + ((encode == null || encode) ? param : param));
    } else {
        for (var i in param) {
            var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            arr.push(pars(param[i], k, encode));
        }
    }
    return arr.join("&");
};

// 对象通过Key排序的函数
function objKeySort(arys) {
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    let newkey = Object.keys(arys).sort();
    let newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (let i = 0; i < newkey.length; i++) {
        //遍历newkey数组
        newObj[newkey[i]] = arys[newkey[i]];
        //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; //返回排好序的新对象
}

export function signActionTime(type, params) {
    //token
    let token = "";
    let secretKey = "";
    // let aData = storage.getLocal('login-token')
    let aData = store.getters["authData"];
    aData && aData.token && (token = aData.token , secretKey = aData.secretKey);
    //type
    let requestType = type.toUpperCase();
    //body
    let d = '';
    let paramsStr = '';
    if (requestType == 'POSTJSON') {
        d = params ? JSON.stringify(params) : '';
    } else {
        paramsStr = params ? pars(objKeySort(params)) : '';
    }
    let bodyMd5 = md5(d).toString();
    //time
    let time = new Date().getTime().toString();
    let sign = md5(token + secretKey + time + paramsStr + bodyMd5).toString();
    //header
    let header = {};
    switch (requestType) {
        case "GET":
            header = {
                "Accept": "application/json",
                token,
                time,
                r: sign
            };
            break;
        case "POSTFORM":
            header = {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                token,
                time,
                r: sign
            };
            break;
        case "POSTJSON":
            header = {
                "Content-Type": "application/json; charset=utf-8",
                token,
                time,
                r: sign
            }
            break;
    }
    return header;    
}

export function noSignAction(type) {
    //token
    let token = "";
    let aData = store.getters["authData"];
    aData && aData.token && (token = aData.token);
    //type
    let requestType = type.toUpperCase();
    //
    let header;
    switch (requestType) {
        case "GET":
            header = {
                "Accept": "application/json",
                token,
                time: '1',
                r: '1'
            };
            break;
        case "POSTFORM":
            header = {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                token
            };
            break;
        case "POSTJSON":
            header = {
                "Content-Type": "application/json; charset=utf-8",
                token
            }
            break;
    }
    return header;
}



// WEBPACK FOOTER //
// ./src/server/headerToken.js